// @ts-check
import { LBButton } from '@linearb/buzz';
import { pluralize } from 'common/utils/utils';

const SelectedEntitiesCounter = ({
  entityName,
  count,
  toggleIsSelectedOnly
}) => {
  return (
    <div className='mr-2'>
      <LBButton variant='ghost' onClick={toggleIsSelectedOnly}>
        {pluralize(count, entityName)} selected
      </LBButton>
    </div>
  );
};

export default SelectedEntitiesCounter;
